module.exports = __webpack_public_path__ + "img/illegal_setout_screenshot.af64779e.png";